import React, { useEffect } from 'react';
import '../styles/index.css';
import { useHistory } from 'react-router';
import useRouteWithAuthZMiddleware from '@amzn/carrierlogistics-commons/dist/middlewares/useRouteWithAuthZMiddleware';
import { initializeAWSRum } from '@amzn/carrierlogistics-commons/dist/utils/cloudwatchRum';
import Layout from '../containers/Layout';
import {
  MONS_OVERRIDE_COOKIE,
  SITE_QUERY_PARAM,
} from '../constants/externalPassportUIConstants';
import getSettings from '../utils/auth/getSettings';
import { setCookie } from '../utils/cookieUtils';
import window from '../utils/window';
import { isAuthorizedPage } from '../utils/authorizedPageUtils';
import { sideNavItemsExternal } from '../config/sideMenuNavItems';
import { LANDING_PAGE } from '../config/navigationalRoutes';
import { exceptedAuthorizedPages } from '../config/nonSignedInPageRoutes';
import { isLocal } from '../config/env';

const App = () => {
  const history = useHistory();
  const { isLoading, isAuthorized } = useRouteWithAuthZMiddleware(
    isAuthorizedPage,
    sideNavItemsExternal,
    exceptedAuthorizedPages
  );
  const isUnAuthorizedAccess = !isLoading && !isAuthorized;
  const site = history.location.search.split(`${SITE_QUERY_PARAM}=`)[1];
  useEffect(() => {
    getSettings().then(({ devSiteCookies }) => {
      if (!devSiteCookies || !site) return;
      setCookie(MONS_OVERRIDE_COOKIE, devSiteCookies[site]);
      history.push({
        search: '',
      });
      window.location.reload();
      // once cookie is updated should also
      // reload the page to get the page from the desired UI bucket
    });
  }, [site, history]);
  useEffect(() => {
    if (isUnAuthorizedAccess) {
      history.push(LANDING_PAGE);
    }
  }, [history, isUnAuthorizedAccess]);

  useEffect(() => {
    if (!isLocal()) {
      getSettings().then(({ rumUIParams }) => {
        initializeAWSRum(rumUIParams);
      });
    }
  }, []);
  return <Layout isLoading={isLoading} />;
};

export default App;
